import axios from "axios";

axios["defaults"].headers.common['Content-type'] = "application/json";
if (process.env.NODE_ENV == 'development')
    axios["defaults"].baseURL = "https://localhost/subscription/";
axios["defaults"].withCredentials = true;

export default axios;